/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { SparseMatrixDependencies } from './dependenciesSparseMatrixClass.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createSparse } from '../../factoriesAny.js';
export var sparseDependencies = {
  SparseMatrixDependencies,
  typedDependencies,
  createSparse
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesSparse.generated.js
// module id = 1477
// module chunks = 2